var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "card border-0 rounded-lg" },
    [
      _vm.loading && !_vm.list.length
        ? _c("div", { staticClass: "d-flex justify-center" }, [
            _c("i", { staticClass: "far fa-spinner-third fa-spin" }),
          ])
        : _c("div", { staticClass: "card-list" }, [
            _c(
              "div",
              {
                staticClass:
                  "card-list-header d-flex justify-content-between align-items-top mb-2",
              },
              [
                _vm.opportunityState
                  ? _c("div", [
                      _c(
                        "h6",
                        {
                          staticClass: "m-0",
                          class: [
                            _vm.opportunityState.notActiveOpportunities
                              ? "text-success"
                              : "text-secondary",
                          ],
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.opportunityStateLabel || "Opportunities"
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                      _c("small", [
                        _vm._v(
                          _vm._s(_vm.listCount) +
                            " " +
                            _vm._s(
                              _vm.opportunityState.notActiveOpportunities
                                ? "Closed"
                                : "Opportunities"
                            )
                        ),
                      ]),
                    ])
                  : _c("div", [
                      _c("h6", { staticClass: "m-0" }, [
                        _vm._v("Opportunities"),
                      ]),
                    ]),
                _c(
                  "a",
                  {
                    staticClass: "btn btn-link",
                    on: {
                      click: function ($event) {
                        return _vm.addNewOpportunity()
                      },
                    },
                  },
                  [
                    _c("i", {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover",
                          modifiers: { hover: true },
                        },
                      ],
                      class: _vm.opportunity
                        ? "far fa-times fa-fw"
                        : "far fa-plus fa-fw",
                      attrs: { title: "Add Opportunity" },
                    }),
                  ]
                ),
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "alert alert-info d-flex justify-content-between align-items-center border-0",
              },
              [
                _c("div", { staticClass: "small" }, [
                  _vm._v("Annualized value"),
                ]),
                _c("div", { staticClass: "font-weight-bold" }, [
                  _vm._v(_vm._s(_vm._f("currency")(_vm.annualizedValue || 0))),
                ]),
              ]
            ),
            _c(
              "div",
              { staticClass: "card-list-body" },
              [
                _vm.sortParams.orderBy === "sortIndex"
                  ? _c(
                      "Container",
                      {
                        attrs: {
                          "group-name": "opportunities",
                          "get-child-payload": _vm.getChildPayload,
                        },
                        on: { drop: _vm.onDrop },
                      },
                      _vm._l(_vm.list, function (item) {
                        return _c("Draggable", { key: item._id }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "card border-0 rounded-lg card-kanban text-decoration-none text-secondary mb-3 p-3",
                            },
                            [
                              _c("OpportunityItem", {
                                attrs: {
                                  opportunity: item,
                                  "visible-opportunity-state": !_vm.opportunityState,
                                },
                                on: {
                                  remove: function ($event) {
                                    return _vm.deleteOpportunity(item)
                                  },
                                  edit: function ($event) {
                                    return _vm.editOpportunity(item)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      }),
                      1
                    )
                  : _c(
                      "div",
                      _vm._l(_vm.list, function (item) {
                        return _c("div", { key: item._id }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "card border-0 rounded-lg card-kanban text-decoration-none text-secondary mb-3 p-3",
                            },
                            [
                              _c("OpportunityItem", {
                                attrs: {
                                  opportunity: item,
                                  "visible-opportunity-state": !_vm.opportunityState,
                                },
                                on: {
                                  remove: function ($event) {
                                    return _vm.deleteOpportunity(item)
                                  },
                                  edit: function ($event) {
                                    return _vm.editOpportunity(item)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      }),
                      0
                    ),
                _vm.canLoadMore
                  ? _c(
                      "div",
                      { staticClass: "mt-2 d-flex justify-content-end" },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: {
                              disabled: _vm.loading,
                              size: "sm",
                              variant: "link",
                              block: "",
                            },
                            on: { click: _vm.loadNextOpportunities },
                          },
                          [_vm._v("\n          Load More\n        ")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
      _c(
        "b-modal",
        {
          ref: "modal",
          attrs: {
            title: "Opportunity",
            size: "md",
            "hide-footer": "",
            "modal-class": "modal right fade",
            "dialog-class":
              "modal-dialog modal-dialog-slideout modal-dialog-slideout-right modal-dialog-slideout-md",
          },
          on: {
            hide: function ($event) {
              _vm.opportunity = null
            },
          },
        },
        [
          _vm.opportunity
            ? _c("OpportunityForm", {
                attrs: {
                  opportunity: _vm.opportunity,
                  customer: _vm.customer,
                  company: _vm.company,
                },
                on: {
                  saved: function ($event) {
                    return _vm.hideOpportunityModalAndReload()
                  },
                  cancel: function ($event) {
                    return _vm.hideOpportunityModal($event)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }